/* eslint-disable react/no-unescaped-entities */
/* eslint-disable max-len */
import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import ArrowBackIosOutlinedIcon from '@mui/icons-material/ArrowBackIosOutlined';
import { useNavigate } from 'react-router-dom';

const TermsAndConditions = () => {
  const navigate = useNavigate();
  return (
    <Box sx={{
      width: '100%', backgroundColor: '#F5F8FA', display: 'flex', flexDirection: 'column', height: '100%', padding: '40px', gap: '20px',
    }}
    >
      <Box sx={{
        width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', margin: '0 auto',
      }}
      >
        <Typography sx={{ color: '#1967D2', fontWeight: '500', fontSize: '40px' }}>Terms & Conditions</Typography>
        <Button variant="outlined" onClick={() => navigate('/')}>
          <ArrowBackIosOutlinedIcon />
          {' '}
          Back To Website
        </Button>
      </Box>
      <Box sx={{ width: '70%', margin: '0 auto', textAlign: 'justify' }}>
        <Typography sx={{
          color: '#000', fontWeight: '500', fontSize: '22px', margin: '10px 0',
        }}
        >
          Welcome to Access Media
        </Typography>
        <Typography sx={{
          color: '#69798A', fontWeight: '500', fontSize: '16px', margin: '10px 0',
        }}
        >
          Thanks for using our products and services ("Services"). The Services are provided by Accessin Media Connect Ltd, located at 12028 Nkwashi Estates, Lusaka-Zambia.
        </Typography>
        <Typography sx={{
          color: '#69798A', fontWeight: '500', fontSize: '16px', margin: '10px 0',
        }}
        >
          By using our Services, you are agreeing to these terms including any subsequent changes or modifications. Please read them carefully. If you do not agree to these Terms, please do not use the accessinmedia.com website or any of our Services and products.
        </Typography>
        <Typography sx={{
          color: '#69798A', fontWeight: '500', fontSize: '16px', margin: '10px 0',
        }}
        >
          Our Services are very diverse, so sometimes additional terms or product requirements (including age requirements) may apply. Additional terms will be available with the relevant Services, and those additional terms become part of your agreement with us if you use those Services.
        </Typography>
      </Box>
      <Box sx={{ width: '70%', margin: '0 auto', textAlign: 'justify' }}>
        <Typography sx={{
          color: '#000', fontWeight: '500', fontSize: '22px', margin: '10px 0',
        }}
        >
          A. Personal Data
        </Typography>
        <Typography sx={{
          color: '#69798A', fontWeight: '500', fontSize: '16px', margin: '10px 0',
        }}
        >
          Personal Data is any information that relates to an identified or identifiable individual. The Personal Data that you provide directly to us through our Sites will be apparent from the context in which you provide the data. In particular:
        </Typography>
        <Typography sx={{
          color: '#69798A', fontWeight: '500', fontSize: '16px', margin: '10px 0',
        }}
        >
          When you register for a Accessin Media account we collect your full name, email address, IP Addresses, browser fingerpring and account log-in credentials.
        </Typography>
        <Typography sx={{
          color: '#69798A', fontWeight: '500', fontSize: '16px', margin: '10px 0',
        }}
        >
          When you fill-in our online form to contact our sales team, we collect your full name, work email, country, and anything else you tell us about your project, needs and timeline.
        </Typography>
      </Box>
      <Box sx={{ width: '70%', margin: '0 auto', textAlign: 'justify' }}>
        <Typography sx={{
          color: '#000', fontWeight: '500', fontSize: '22px', margin: '10px 0',
        }}
        >
          B. Collected Information
        </Typography>
        <Typography sx={{
          color: '#69798A', fontWeight: '500', fontSize: '16px', margin: '10px 0',
        }}
        >
          We also may collect information about your online activities on websites and connected devices over time and across third-party websites, devices, apps and other online features and services. We use Google Analytics on our Sites to help us analyze Your use of our Sites and diagnose technical issues.
        </Typography>
        <Typography sx={{
          color: '#69798A', fontWeight: '500', fontSize: '16px', margin: '10px 0',
        }}
        >
          To learn more about the cookies that may be served through our Sites and how You can control our use of cookies and third-party analytics, please see our Cookie Policy.
        </Typography>
      </Box>
      <Box sx={{ width: '70%', margin: '0 auto', textAlign: 'justify' }}>
        <Typography sx={{
          color: '#000', fontWeight: '500', fontSize: '22px', margin: '10px 0',
        }}
        >
          1. Privacy & Copyright Protection
        </Typography>
        <Typography sx={{
          color: '#69798A', fontWeight: '500', fontSize: '16px', margin: '10px 0',
        }}
        >
          Accessin Media’s privacy policies explain how we treat your personal data and protect your privacy when you use our Services. By using our Services, you agree that Accessin Media can use such data in accordance with our privacy policies.
        </Typography>
        <Typography sx={{
          color: '#69798A', fontWeight: '500', fontSize: '16px', margin: '10px 0',
        }}
        >
          We provide information to help copyright holders manage their intellectual property online. If you think somebody is violating your copyrights and want to notify us, you can find information about submitting notices and Accessin Media's policy about responding to notices in our Help Center.
        </Typography>
      </Box>
      <Box sx={{ width: '70%', margin: '0 auto', textAlign: 'justify' }}>
        <Typography sx={{
          color: '#000', fontWeight: '500', fontSize: '22px', margin: '10px 0',
        }}
        >
          2. Privacy & Communications
        </Typography>
        <Typography sx={{
          color: '#69798A', fontWeight: '500', fontSize: '16px', margin: '10px 0',
        }}
        >
          You acknowledge and agree that that Accessin Media may occasionally send you communications regarding your account or the Service via email.
        </Typography>
        <Typography sx={{
          color: '#69798A', fontWeight: '500', fontSize: '16px', margin: '10px 0',
        }}
        >
          You can control the email notifications from your account settings page. There may also be direct communications from our support executives whenever we have to follow up or have questions regarding your files. See the Privacy Policy, which is incorporated into this Agreement by reference.
        </Typography>
      </Box>
      <Box sx={{ width: '70%', margin: '0 auto', textAlign: 'justify' }}>
        <Typography sx={{
          color: '#000', fontWeight: '500', fontSize: '22px', margin: '10px 0',
        }}
        >
          3. Service Rates
        </Typography>
        <Typography sx={{
          color: '#69798A', fontWeight: '500', fontSize: '16px', margin: '10px 0',
        }}
        >
          Accessin Media reserves the sole right to alter, modify, change or withdraw the transcription rates offered or quoted for a specific file or all files or as stated on our website. We may ask for additional payment depending on our assessment of the time and effort required, such assessment to be in good faith. By using our Services you acknowledge and agree that our assessment is final and binding and refusal to accept that will lead to immediate cancellation of the order. For the avoidance of doubt, no fees are payable by you for any such cancelled orders where additional charges were levied.
        </Typography>
      </Box>
      <Box sx={{ width: '70%', margin: '0 auto', textAlign: 'justify' }}>
        <Typography sx={{
          color: '#000', fontWeight: '500', fontSize: '22px', margin: '10px 0',
        }}
        >
          4. Acceptable Use & Conduct
        </Typography>
        <Typography sx={{
          color: '#69798A', fontWeight: '500', fontSize: '16px', margin: '10px 0',
        }}
        >
          You are solely responsible for the data which is submitted to Accessin Media in relation to the Service. You agree to indemnify, defend, hold harmless Accessin Media and its suppliers from any and all loss, cost, liability and expense arising from or related to your data, your use of the Service or your violation of these terms. You agree to defend and/or settle any third party claim, action, suit or proceeding made against Accessin Media and its suppliers alleging that Accessin Media’s use of your data or files infringes the intellectual property rights of a third party ("IP Claim"), provided Accessin Media will give you (a) prompt written notice of such IP Claim, (b) sole control over the defense and settlement of such claim, and (c) cooperation in the defense of the claim. Your obligation for such IP Claim will not apply if the actual or alleged infringement results solely from any unauthorized modification, alteration or addition to your data or files.
        </Typography>
        <Typography sx={{
          color: '#69798A', fontWeight: '500', fontSize: '16px', margin: '10px 0',
        }}
        >
          The Software and Services are made available to you, your company, and/or your customers for personal or commercial use, which use must be in compliance with all applicable laws, rules and regulations and must not infringe or violate third party rights.
        </Typography>
        <Typography sx={{
          color: '#69798A', fontWeight: '500', fontSize: '16px', margin: '10px 0',
        }}
        >
          Any unauthorized use of any Accessin Media's Service is a violation of this Agreement and certain federal and state laws. Such violations may subject the unauthorized user and his or her agents to civil and criminal penalties.
        </Typography>
      </Box>
      <Box sx={{ width: '70%', margin: '0 auto', textAlign: 'justify' }}>
        <Typography sx={{
          color: '#000', fontWeight: '500', fontSize: '22px', margin: '10px 0',
        }}
        >
          5. Cancellation Policy
        </Typography>
        <Typography sx={{
          color: '#69798A', fontWeight: '500', fontSize: '16px', margin: '10px 0',
        }}
        >
          Minimum 24 hours (during public working days only) notice of cancellation is required. Notification for instance, in person, via email, mobile phone text message or any other means will be accepted subject to confirmation in writing.
        </Typography>
      </Box>
      <Box sx={{ width: '70%', margin: '0 auto', textAlign: 'justify' }}>
        <Typography sx={{
          color: '#000', fontWeight: '500', fontSize: '22px', margin: '10px 0',
        }}
        >
          6. Chargeback & Refund Policy
        </Typography>
        <Typography sx={{
          color: '#69798A', fontWeight: '500', fontSize: '16px', margin: '10px 0',
        }}
        >
          Both the Client and ourselves have the right to terminate any Services Agreement for any reason, including the ending of services that are already underway. No refunds shall be offered, where a Service is deemed to have begun and is, for all intents and purposes, underway. Any monies that have been paid to us which constitute payment in respect of the provision of unused services, shall be refunded.
        </Typography>
      </Box>
      <Box sx={{ width: '70%', margin: '0 auto', textAlign: 'justify' }}>
        <Typography sx={{
          color: '#000', fontWeight: '500', fontSize: '22px', margin: '10px 0',
        }}
        >
          7. Warranties & Representations
        </Typography>
        <Typography sx={{
          color: '#69798A', fontWeight: '500', fontSize: '16px', margin: '10px 0',
        }}
        >
          Accessin Media represents and warrants that it will provide personnel with sufficient skill and knowledge to perform the Service and that the Service will be performed in a professional and workmanlike manner. Except for the foregoing warranty, you understand and agree that the Software and Service is provided "as is" and Accessin Media its affiliates, suppliers and Resellers expressly disclaim all warranties of any kind, beyond the refund or re-review, whichever is applicable, express or implied, including without limitation any warranty of merchantability, fitness for a particular purpose, non-infringement or bailment of your data on Accessin Media's servers.
        </Typography>
        <Typography sx={{
          color: '#69798A', fontWeight: '500', fontSize: '16px', margin: '10px 0',
        }}
        >
          Accessin Media, its affiliates, suppliers and Resellers make no warranty or representation, other than the refund or re-review, whichever is applicable, regarding the results that may be obtained from the use of the Service, the security of the Service, or that the Service will meet any user's requirements beyond the re-review. Use of the Service is at your sole risk. You will be solely responsible for any damage to You resulting from the use of the Service. The entire risk arising out of use, security or performance of the Service remains with you.
        </Typography>
        <Typography sx={{
          color: '#69798A', fontWeight: '500', fontSize: '16px', margin: '10px 0',
        }}
        >
          Without limiting the foregoing, the Service is not designed or licensed for use in hazardous environments requiring fail-safe controls, including without limitation operation of nuclear facilities, aircraft navigation/communication systems, air traffic control, and life support or weapons systems.
        </Typography>
      </Box>
      <Box sx={{ width: '70%', margin: '0 auto', textAlign: 'justify' }}>
        <Typography sx={{
          color: '#000', fontWeight: '500', fontSize: '22px', margin: '10px 0',
        }}
        >
          8. Limitation of Liability
        </Typography>
        <Typography sx={{
          color: '#69798A', fontWeight: '500', fontSize: '16px', margin: '10px 0',
        }}
        >
          In no event shall Accessin Media be liable for any indirect, special, incidental, consequential or punitive damages (including but not limited to loss of use, loss of profits, or loss of data) whether in an action in contract, tort (including but not limited to negligence), equity or otherwise, arising out of or in any way connected with the use of or inability to use this site or the materials therein or resulting from unauthorized access to or alteration of data.
        </Typography>
      </Box>
      <Box sx={{ width: '70%', margin: '0 auto', textAlign: 'justify' }}>
        <Typography sx={{
          color: '#000', fontWeight: '500', fontSize: '22px', margin: '10px 0',
        }}
        >
          9. Termination of Service
        </Typography>
        <Typography sx={{
          color: '#69798A', fontWeight: '500', fontSize: '16px', margin: '10px 0',
        }}
        >
          We reserve the right to terminate or suspend your account at any time. You also have the option of canceling your account at any time without penalty. In the event of account cancelation you will lose all data related to your account. We also reserve the right to refuse service without providing a reason.
        </Typography>
      </Box>
      <Box sx={{ width: '70%', margin: '0 auto', textAlign: 'justify' }}>
        <Typography sx={{
          color: '#000', fontWeight: '500', fontSize: '22px', margin: '10px 0',
        }}
        >
          10. Conditions
        </Typography>
        <Typography sx={{
          color: '#69798A', fontWeight: '500', fontSize: '16px', margin: '10px 0',
        }}
        >
          We reserve the right to modify these Terms of Service at any time without notice. Please review these Terms of Service on occasion as they may change in the future. We may, but have no obligation to, remove accounts and content containing what we determine, in good faith and on reasonable grounds, as unlawful, offensive, threatening, defamatory, obscene or otherwise objectionable material. We will remove content that violates any party's intellectual property, if we have been notified of such violation, or these Terms of Service. An account terminated by Accessin Media will not be backed-up for any reason and will be immediately deleted from our servers.
        </Typography>
      </Box>
    </Box>
  );
};

export default TermsAndConditions;
